export const UA = 'uk-UA';
export const RU = 'ru-RU';
export const EN = 'en-US';
export const AR = 'ar-SA';
